(function () {
  angular.module("akitabox.ui.dialogs.autocomplete", [
    "ngMaterial",
    "akitabox.core",
    "akitabox.core.constants",
    "akitabox.core.toast",
  ]);
})();
